export { default } from './SimplePagination';
